import createVueComponent from '../createVueComponent';

const Copyleft = createVueComponent('CopyleftIcon', [
  ['circle', { cx: '12', cy: '12', r: '10' }],
  ['path', { d: 'M9 9.35a4 4 0 110 5.3' }],
]);

export default Copyleft;
